module.exports = __webpack_public_path__ + "static/marche-ext-2a71ab6e14106a7a78ec06dfd4fa062d.eot";